import { FC } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

interface AuctionDetailDrawerSlots {
  image?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  countdown?: React.ReactNode;
  bidBlock: React.ReactNode;
  bidHistory?: React.ReactNode;
}

export interface AuctionDetailDrawerLayoutProps {
  slots: AuctionDetailDrawerSlots;
}

export const AuctionDetailDrawerLayout: FC<AuctionDetailDrawerLayoutProps> = ({ slots }) => {
  const theme = useTheme();

  return (
    <Stack gap={3} sx={{ overflowX: "hidden" }}>
      {slots.image && <Box>{slots.image}</Box>}
      <Stack gap={2}>
        <Stack gap={1}>{slots.title}</Stack>
        {slots.description && (
          <Box
            sx={{
              ...theme.typography.body2,
              color: theme.palette.forms?.text.moderate,
            }}
          >
            {slots.description}
          </Box>
        )}
      </Stack>
      {slots.bidBlock}
      {slots.countdown}
      <Stack paddingBottom={2}>{slots.bidHistory && <>{slots.bidHistory}</>}</Stack>
    </Stack>
  );
};
